


























































































































































































































































import moment from "moment";
import Vue from "vue";
import { mapGetters } from "vuex";

//Vue Components
import ScheduleConfigurationComponent from "../../ServiceAndUpdates/ScheduleConfiguration/ScheduleConfigurationComponent.vue";

//Model
import { DeviceOnBoardingResultEnumToLabel } from "@/model/communication/device/DeviceOnBoardingCommand";
import { logsFamilyEnumLabel } from "@/model/data/enums/LogsFamilyEnum";
import { UserEventTypeEnum } from "@/model/data/enums/UserEventTypeEnum";
import { getLicenseModuleLabel, LicenseModuleEnum } from "@/model/data/License/LicenseModuleEnum";
import { ScheduleTypeEnumToI18n } from "@/model/data/scheduleSettings/ScheduleTypeEnum";
import { UserEvent } from "@/model/data/userEvents/UserEvent";

export default Vue.extend({
    components: { ScheduleConfigurationComponent },
    props: {
        event: Object as () => UserEvent,
        type: String,
    },
    data() {
        return {
            moment,
            UserEventTypeEnum,
            LicenseModuleEnum,
        };
    },
    computed: {
        ...mapGetters(["userTimeFormat", "userDateFormat", "longDateFormat"]),
    },
    methods: {
        DeviceOnBoardingResultEnumToLabel,
        ScheduleTypeEnumToI18n,
        getLicenseModuleLabel,
        logsFamilyEnumLabel,
        licenseToString(license) {
            let licenseString = [];
            if ((license & LicenseModuleEnum.ServiceAndUpdatesManagement) != LicenseModuleEnum.None)
                licenseString.push(this.$t(getLicenseModuleLabel(LicenseModuleEnum.ServiceAndUpdatesManagement)));

            if ((license & LicenseModuleEnum.FitnessStatistics) != LicenseModuleEnum.None) licenseString.push(this.$t(getLicenseModuleLabel(LicenseModuleEnum.FitnessStatistics)));

            if ((license & LicenseModuleEnum.CashFlowManagement) != LicenseModuleEnum.None)
                licenseString.push(this.$t(getLicenseModuleLabel(LicenseModuleEnum.CashFlowManagement)));

            if ((license & LicenseModuleEnum.SecurityManagement) != LicenseModuleEnum.None)
                licenseString.push(this.$t(getLicenseModuleLabel(LicenseModuleEnum.SecurityManagement)));

            if ((license & LicenseModuleEnum.PredictiveMaintenance) != LicenseModuleEnum.None)
                licenseString.push(this.$t(getLicenseModuleLabel(LicenseModuleEnum.PredictiveMaintenance)));

            if ((license & LicenseModuleEnum.RemoteLink) != LicenseModuleEnum.None) licenseString.push(this.$t(getLicenseModuleLabel(LicenseModuleEnum.RemoteLink)));
            return licenseString.join(", ");
        },
    },
});
